import { useCallback, useState } from 'react'
import { useSlate } from 'slate-react'

import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { insertIFrame } from 'core-components/library/richTextEditor/helpers/slateHelper'
import { TOOLBAR_BUTTONS } from 'core-components/library/richTextEditor/interface/IToolbar'
import { TIFrame } from 'core-components/library/richTextEditor/interface/TIFrame'

import { TOOLBAR_TITLES } from '../../constants'

import { IFrameSettingsDialog } from './IFrameSettingsDialog'

interface IProps {
  disabled: boolean
  className?: string
}

export const IFrameButton = (props: IProps) => {
  const [headerVisible, setHeaderVisible] = useState(false)

  const editor = useSlate()

  const addIFrame = (settings: TIFrame) => {
    insertIFrame(editor, settings)
    onClose()
  }

  const onClose = useCallback(() => {
    setHeaderVisible(false)
  }, [])

  return (
    <>
      <Button
        className={props.className}
        onClick={() => {
          setHeaderVisible(true)
        }}
        title={TOOLBAR_TITLES[TOOLBAR_BUTTONS.IFrame]}
        disabled={props.disabled}
        color={'grey'}
        variant={'text'}
        iconButton={'kbase kbase-iframe'}
      />
      <ModalDialog
        title={'IFrame Settings'}
        content={IFrameSettingsDialog}
        contentProps={{
          iframeSettings: {},
          onSave: (settings: TIFrame) => {
            addIFrame(settings)
          },
          onCancel: () => onClose(),
        }}
        size={'auto'}
        onClose={onClose}
        show={headerVisible}
      />
    </>
  )
}
